import RoutingForm1Meta, { IRoutingModelFormMeta } from './RoutingForm1Meta';

const RoutingForm2Meta: IRoutingModelFormMeta = {
  ...RoutingForm1Meta,
  minRangeBin: { 
    ...RoutingForm1Meta.minRangeBin, 
    name: 'minRangeBin2' 
  },
  maxRangeBin: { 
    ...RoutingForm1Meta.maxRangeBin, 
    name: 'maxRangeBin2' 
  },
  transactionType: {
    ...RoutingForm1Meta.transactionType,
    name: 'transactionType2',
  },
  AID: { 
    ...RoutingForm1Meta.AID, 
    name: 'AID2' 
  },
  withPinOrNot: { 
    ...RoutingForm1Meta.withPinOrNot, 
    name: 'withPinOrNot2' 
  },
  primaryInterface: {
    ...RoutingForm1Meta.primaryInterface,
    name: 'primaryInterface2',
  },
  secondaryInterface: {
    ...RoutingForm1Meta.secondaryInterface,
    name: 'secondaryInterface2',
  },
};

export default RoutingForm2Meta;
